/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 25/9/2020
 */
import BaseObject from "@shared/BaseObject.js";
import QwoachDataManager from "@/core/js/backend/QwoachDataManager";
import {deleteConfirmDialog, messageDialogSimple} from "@/core/components/Dialogs/dialog";


export default class SessionTypeHelper extends BaseObject {

	dataManager: QwoachDataManager
	vueComponent


	constructor(vueComponent) {
		super();
		this.dataManager = vueComponent.$dataManager;
		this.vueComponent = vueComponent
	}


	async copySessionType(sessionType){
		console.log("copySessionType: sessionType = ", sessionType)
		let eventType = await this.vueComponent.handleAsync(() => this.dataManager.apiPostCopyEventType(sessionType))
		console.log("copySessionType: eventType new = ", eventType)
		return eventType
	}

	async deleteSessionType(sessionType){
		if(sessionType.attachedWorkflowIds && sessionType.attachedWorkflowIds.length > 0){
			await messageDialogSimple("Can't delete this session type", "This session type is a part of one or more workflows and it can't be deleted. Please contact support for farther assistance.")
			return false
		}
		let res = await deleteConfirmDialog({
			itemName: "session type",
			additionalText: "WARNING: If it's used in one of your packages, your clients won't be able to schedule sessions for that package."
			// additionalText: "WARNING: This will also delete all the forms associated with this session type.",
		})
		if(res){
			await this.vueComponent.handleAsync(() => this.dataManager.apiPostDeleteEventType(sessionType))
		}
		return res
	}
}
